module.exports = __webpack_public_path__ + "static/media/accomplish.0128c2aa.webp";